import { render, staticRenderFns } from "./UnreadMemosSummary.vue?vue&type=template&id=583d3d0e&"
import script from "./UnreadMemosSummary.vue?vue&type=script&lang=js&"
export * from "./UnreadMemosSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports